import actions from './actions';
import api, { modelName } from './api';
import column from '../../abstract/column';
import vars from '../../abstract/vars';

export default {
  actions,
  api,
  modelName,
  columns: {
    id: column({ label: 'ID', primary: true, grid: false }),
    name: column({
      label: 'Nazwa',
    }),
  },
  vars: vars({
    noItemsText: 'Brak grup',
    sidebarLabel: 'Podgląd grupy',
  }),
  topRightActions: {
    create: {
      label: 'Dodaj grupę',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push('/mailing/groups/add'),
    },
  },
};
